import Form from "../../../components/form/Form";
import { LOGIN_FORM_CONSTANTS } from "../../../constants/login.form.constant";

import { cn } from "@/lib/utils";
import { GalleryVerticalEnd } from "lucide-react";
import useLogin from "./useLogin";
export default function LoginPage() {
	const { error, control, errors, handleSubmit, isSubmitting, onSubmit, methods } = useLogin();

	return (
		<div className="grid min-h-svh lg:grid-cols-2">
			<div className="flex flex-col gap-4 p-6 md:p-10">
				<div className="flex justify-center gap-2 md:justify-start">
					<a href="#" className="flex items-center gap-2 font-medium">
						<div className="flex h-6 w-6 items-center justify-center rounded-md bg-primary text-primary-foreground">
							<GalleryVerticalEnd className="size-4" />
						</div>
						Watcher Inc.
					</a>
				</div>
				<div className="flex flex-1 items-center justify-center">
					<div className="w-full max-w-xs">
						<form onSubmit={() => handleSubmit(onSubmit)} className={cn("flex flex-col gap-6")}>
							<div className="flex flex-col items-center gap-2 text-center">
								<h1 className="text-2xl font-bold">Login to your account</h1>
								<p className="text-balance text-xs text-muted-foreground">Enter your username below to login to your account</p>
							</div>
							<Form fields={LOGIN_FORM_CONSTANTS} control={control} method={methods} onClick={handleSubmit((data) => onSubmit(data))} errors={errors} isSubmitting={isSubmitting} style="w-full" />
						</form>
					</div>
				</div>
			</div>
			<div className="relative hidden bg-muted lg:block">
				<img src={require("../../../assets/images/bg/bg-1.jpg")} alt="Image" className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.2] dark:grayscale" />
			</div>
		</div>
	);
}
